/* @ngInject */
function ConditionalController ($scope, $translate, $timeout, ToastService, ConditionalService) {
  let options = null

  const api = {
    _setOptions,
    _setTypes,
    _validateSelectedOptions,
    _removeOptionFromValues,
    _disableSelectedActions,
    _enableDisableTypeOnChange,
    _setTypeDisabled,
    _enableDisableOptionsOnChange,
    _setOptionDisabled,
    _validateFields,
    _setSelectedOptions,
    _setSelectedType,
    _getOptionsForCarrossel,
    _getOptionsForDropdownOrRadio,
    _setSelectedOptionsForCarrossel,
    _setSelectedOptionsForDropdownOrRadio
  }

  this.getApi = () => api

  activate()

  function activate () {
    api._setOptions()
    api._setTypes()

    $timeout(() => {
      api._setSelectedOptions()
      api._setSelectedType()
    }, 500)
  }

  const deregisterUpdateOptions = $scope.$on('conditional.updateOptions', (e, fieldId) => {
    if (fieldId !== $scope.field.id) return

    const inputs = $(`.conditional-container.field-${fieldId} .conditional-rule .rule-texts uds-input-multiselect`)
    inputs.each((index, input) => {
      input.clearComponentData()
    })

    $timeout(() => {
      api._setOptions()
      api._setSelectedOptions()
    }, 500)
  })

  const deregisterUpdateTypes = $scope.$on('conditional.updateTypes', () => {
    api._setTypes()
  })

  const deregisterValidateFields = $scope.$on('conditional.validateFields', () => {
    api._validateFields()
  })

  $scope.$on('$destroy', () => {
    deregisterUpdateOptions()
    deregisterUpdateTypes()
    deregisterValidateFields()
  })

  $scope.addConditionalRule = () => {
    $scope.field.actions.push(ConditionalService.createNewConditionalAction())
  }

  $scope.deleteConditionalRule = (rule) => {
    const index = $scope.field.actions.findIndex(item => item.id === rule.id)
    if (index !== -1) {
      if ($scope.field.actions[index].typeObj || $scope.field.actions[index].initialType) {
        const typeObj = $scope.field.actions[index].typeObj || $scope.field.actions[index].initialType
        api._setTypeDisabled(typeObj, false)
      }
      if ($scope.field.defaultRadioOptions && $scope.field.actions[index].options) {
        api._setOptionDisabled($scope.field.actions[index].options, false)
      }
      $scope.field.actions.splice(index, 1)
    }
  }

  $scope.onSearchOptions = (event) => {
    const term = event.detail.search.toLowerCase()
    const results = options.filter(item => item.label.toLowerCase().includes(term))
    $scope.options = results
  }

  $scope.onChangeOptions = (event, rule, ruleIndex, sections) => {
    const previousOption = rule.options
    const selectedOptions = event.detail

    if (Array.isArray(event.detail)) {
      const { optionWasUsed, fieldUsed } = api._validateSelectedOptions(selectedOptions, ruleIndex)

      if (optionWasUsed) {
        ToastService.showErrorToast($translate.instant('conditional.selectOptionError'))
        const newValue = api._removeOptionFromValues(selectedOptions, fieldUsed)
        $(event.target).attr('value', newValue)
      } else {
        rule.options = selectedOptions
      }
    } else {
      rule.options = selectedOptions
      api._enableDisableOptionsOnChange(previousOption, selectedOptions)
    }
  }

  $scope.onChangeType = (event, rule) => {
    const selectedType = event.detail
    const previousType = rule.typeObj || rule.initialType
    rule.typeObj = selectedType
    rule.type = selectedType.type

    if (rule.type === 'GO_TO_SECTION') {
      rule.sectionId = selectedType.value
    } else {
      rule.sectionId = null
    }

    $scope.field.inconsistentAction = false
    api._enableDisableTypeOnChange(previousType, selectedType)
  }

  $scope.showNewConditionalBtn = () => {
    if ($scope.field.defaultRadioOptions) {
      return $scope.field.actions.length < $scope.options.length
    }

    return $scope.field.actions.length < $scope.types.length
  }

  function _setOptions () {
    if ($scope.field.type === 'CARROSSEL') {
      options = api._getOptionsForCarrossel()
    } else {
      options = api._getOptionsForDropdownOrRadio()
    }

    $scope.options = options
  }

  function _getOptionsForDropdownOrRadio () {
    return $scope.field.fields.map(item => {
      return {
        id: item.id,
        value: item.id,
        label: item.title
      }
    })
  }

  function _getOptionsForCarrossel () {
    return $scope.field.fieldAssets.map(asset => {
      return {
        id: asset.id,
        value: asset.id,
        label: asset.files[0].name
      }
    })
  }

  function _setTypes () {
    $scope.types = []

    $scope.sections.forEach((section, index) => {
      if (section.id === $scope.currentSection) return

      $scope.types.push({
        value: section.id,
        type: 'GO_TO_SECTION',
        label: $translate.instant('conditional.options.goSection') + ' ' + ++index
      })
    })

    $scope.types.push({
      value: 'SUBMIT_FORM',
      type: 'SUBMIT_FORM',
      label: $translate.instant('conditional.options.sendForm')
    })

    api._disableSelectedActions()
  }

  function _validateSelectedOptions (selectedOptions, ruleIndex) {
    const conditionalRules = [...$scope.field.actions]
    conditionalRules.splice(ruleIndex, 1)

    if (!conditionalRules.length) return false

    const info = {
      optionWasUsed: false,
      fieldUsed: null
    }

    let index = 0

    while (!info.optionWasUsed && index < conditionalRules.length) {
      selectedOptions.forEach(item => {
        const fieldUsed = conditionalRules[index].options.find(option => option.value === item.value || option.id === item.value)
        if (fieldUsed) {
          info.fieldUsed = fieldUsed
          info.optionWasUsed = true
        }
      })

      index++
    }

    return info
  }

  function _removeOptionFromValues (options, optionToRemove) {
    const index = options.findIndex(item => item.value === optionToRemove.value || item.value === optionToRemove.id)

    if (index !== -1) {
      options.splice(index, 1)
    }

    return options
  }

  function _disableSelectedActions () {
    $scope.types.forEach(item => {
      const isActionSelected = $scope.field.actions.some(rule => rule.typeObj?.value === item.value || rule.initialType?.value === item.value)
      item.disabled = isActionSelected
    })
  }

  function _enableDisableTypeOnChange (previousType, selectedType) {
    if (previousType) {
      api._setTypeDisabled(previousType, false)
    }

    api._setTypeDisabled(selectedType, true)
  }

  function _setTypeDisabled (type, value) {
    const index = $scope.types.findIndex(item => item.value === type.value)

    if (index !== -1) {
      $scope.types[index].disabled = value
    }
  }

  function _enableDisableOptionsOnChange (previousOption, selectedOption) {
    if (previousOption) {
      api._setOptionDisabled(previousOption, false)
    }

    api._setOptionDisabled(selectedOption, true)
  }

  function _setOptionDisabled (option, value) {
    const index = $scope.options.findIndex(item => item.value === option.value)

    if (index !== -1) {
      $scope.options[index].disabled = value
    }
  }

  function _validateFields () {
    $scope.field.hasInvalidConditionalFields = false

    $scope.field.actions.forEach(rule => {
      const hasAction = !!rule.typeObj || !!rule.initialType
      const hasOptions = rule.options.length > 0 || !Array.isArray(rule.options) || rule.assetOptions.length > 0 || !Array.isArray(rule.assetOptions)
      $(`.conditional-container .conditional-rule .types-${rule.id}`).attr('negative', !hasAction)
      $(`.conditional-container .conditional-rule .options-${rule.id}`).attr('negative', !hasOptions)

      if (!hasAction || !hasOptions) {
        $scope.field.hasInvalidConditionalFields = true
      }
    })
  }

  function _setSelectedOptions () {
    if (!$scope.field.actions.length) return

    if ($scope.field.type === 'CARROSSEL') {
      api._setSelectedOptionsForCarrossel()
    } else {
      api._setSelectedOptionsForDropdownOrRadio()
    }
  }

  function _setSelectedType () {
    if (!$scope.field.actions.length) return

    $scope.field.actions.forEach(action => {
      if (action.type === 'SUBMIT_FORM') {
        action.initialType = {
          value: 'SUBMIT_FORM',
          label: $translate.instant('conditional.options.sendForm')
        }
      } else {
        action.initialType = $scope.types.find(type => type.value === action.sectionId)
      }

      if (action.initialType) {
        api._setTypeDisabled(action.initialType, true)
      }
    })
  }

  function _setSelectedOptionsForDropdownOrRadio () {
    $scope.field.actions.forEach(action => {
      const selectedOptions = action.options.map(option => {
        return {
          value: option.id,
          label: option.title || option.label
        }
      })

      action.initialOptions = $scope.field.defaultRadioOptions ? selectedOptions[0] : selectedOptions
    })
  }

  function _setSelectedOptionsForCarrossel () {
    function getCurrentFile (files, version) {
      return files.find(file => file.version === version)
    }

    $scope.field.actions.forEach(action => {
      if (!action?.assetOptions?.length) return

      const selectedOptions = action.assetOptions.map(option => {
        const file = getCurrentFile(option.asset.files, option.asset.latestFileVersion)
        return {
          value: option.asset.id,
          label: file?.name
        }
      })

      action.initialOptions = selectedOptions
      action.options = [...selectedOptions]
    })
  }
}

export { ConditionalController }
